import React, { useEffect } from 'react';
import './DogHouseRules.css';

function DogHouseRules() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    const dogHouseRules = [
        {number: '1', content: "Children must remain seated with their family unless accompanied by an adult."},
        {number: '2', content: "No running or playing anywhere on the premises. This is a space for adults and dogs to socialize."},
        {number: '3', content: "Infants and toddlers must be closely monitored by their parents at all times."},
        {number: '4', content: "Teenagers must remain seated with their family. No alcohol consumption or sharing of alcoholic beverages."},
        {number: '5', content: "Maximum of two children per family, unless approved by management."},
        {number: '6', content: "Management reserves the right to ask families to leave if children's behavior disrupts the experience of other guests. Repeated incidents may result in restrictions on future visits."}
    ];

    return (
        <div className="dog-house-rules-container">
            <div className="dog-house-rules-title">Family Guidelines</div>
            <div className="dog-house-rules-subtitle">While we are a 21+ establishment, we welcome families who can adhere to the following guidelines. Please note that a waiver must be signed in person on your first visit, and these guidelines must be followed in addition to our Park Rules.</div>
            <div className="dog-house-rules-list">
                {dogHouseRules.map(rule => (
                    <div className="dog-house-rules-item" key={rule.number}>
                        <div className="dog-house-rules-number">{rule.number}.</div>
                        <div className="dog-house-rules-content">{rule.content}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DogHouseRules; 